/* Ruts Atelier — Popup de bienvenida (configurable desde el editor)
   Lee la config de la sección `ruts-popup` (script[data-ruts-popup-config]).
   Fallback a window.RUTS_PROMO para compatibilidad.
   - Frecuencia: once / days / always (localStorage).
   - Captura email en Shopify (form_type=customer, tag newsletter) → Klaviyo.
   - Layout 2 paneles: imagen (izq.) + contenido (der.). En móvil se apila. */
(function () {
  "use strict";

  if (window.__rutsPopupBooted) { if (window.__rutsPopupRun) window.__rutsPopupRun("reboot"); return; }
  window.__rutsPopupBooted = true;

  function readConfig() {
    var el = document.querySelector("[data-ruts-popup-config]");
    if (el) {
      try { return JSON.parse(el.textContent); } catch (e) {}
    }
    var legacy = window.RUTS_PROMO;
    if (legacy) {
      return {
        enable: true, image: legacy.image || null, image_mobile: null,
        img_pos_desktop: "center", img_pos_mobile: "center center", img_h_mobile: 200,
        code: legacy.code || "BIENVENIDA10",
        delay: 2800, exit_intent: true, frequency: "once", freq_days: 7, show_form: true,
        eyebrow: "RUTS ATELIER", title: "Un 10% para empezar",
        desc: "<p>Suscríbete y recibe un <strong>" + (legacy.pct || 10) + "% de descuento</strong> en tu primera compra.</p>",
        placeholder: "Tu correo electrónico", cta: "Quiero mi " + (legacy.pct || 10) + "%",
        fine: "Sin spam. Cancela cuando quieras.", no: "NO, LO PAGO CARO",
        success_title: "¡Bienvenido!", success_text: "Usa este código en el carrito:",
        shop_text: "Empezar a comprar", shop_link: "/collections/novedades",
        colors: { panel: "#F4EEE2", text: "#2E2A24", accent: "#A85A3C", btn_bg: "#2E2A24", btn_text: "#F4EEE2", code: "#A85A3C", input_border: "#CDBFA6" }
      };
    }
    return null;
  }

  var CFG = null;
  var C = {};
  var KEY = "ruts_welcome_v1";
  var DELAY = 2800;
  var PREVIEW_ACTIVE = false;
  var overlayEl = null;

  function refreshConfig() {
    CFG = readConfig();
    C = (CFG && CFG.colors) || {};
    DELAY = (CFG && typeof CFG.delay === "number") ? CFG.delay : 2800;
  }

  var POSTED = false, CAME_FROM_POPUP = false;
  try {
    POSTED = (location.search || "").indexOf("customer_posted=true") !== -1;
    var _pend = sessionStorage.getItem("ruts_popup_pending");
    if (_pend) sessionStorage.removeItem("ruts_popup_pending");
    CAME_FROM_POPUP = _pend === "1";
  } catch (e) {}

  function gated() {
    if (CFG.frequency === "always") return false;
    try {
      var v = localStorage.getItem(KEY);
      if (!v) return false;
      if (CFG.frequency === "days") {
        var ageDays = (Date.now() - parseInt(v, 10)) / 86400000;
        return ageDays < (CFG.freq_days || 7);
      }
      return true;
    } catch (e) { return true; }
  }

  function moveNativeFormHome() {
    if (!overlayEl) return;
    var f = overlayEl.querySelector("form");
    if (!f || !f.querySelector('input[name="contact[email]"]')) return;
    var home = document.querySelector("[data-ruts-popup-form]");
    if (home && !home.querySelector("form")) { home.appendChild(f); }
  }

  function removeExisting() {
    moveNativeFormHome();
    var nodes = document.querySelectorAll(".ruts-pop__ov");
    for (var i = 0; i < nodes.length; i++) { try { nodes[i].remove(); } catch (e) {} }
    overlayEl = null;
  }

  function seen() { if (PREVIEW_ACTIVE) return; try { localStorage.setItem(KEY, Date.now().toString()); } catch (e) {} }

  function injectStyles() {
    if (document.getElementById("ruts-pop-css")) return;
    var s = document.createElement("style");
    s.id = "ruts-pop-css";
    var GRAD = "linear-gradient(150deg," + (C.accent || "#A85A3C") + " 0%,#8a4730 100%)";
    var COVER = "background-size:cover;background-repeat:no-repeat;";
    var imgM = CFG.image_mobile || CFG.image;
    var posD = CFG.img_pos_desktop || "center";
    var posM = CFG.img_pos_mobile || "center center";
    var hM = CFG.img_h_mobile || 200;
    var border = C.input_border || "#CDBFA6";
    var imgD_css = CFG.image
      ? "background-image:url('" + CFG.image + "');background-size:contain;background-repeat:no-repeat;background-position:" + posD
      : "background:" + GRAD;
    var imgM_css = imgM
      ? "background-image:url('" + imgM + "');" + COVER + "background-position:" + posM
      : "background:" + GRAD;
    s.textContent = [
      ".ruts-pop__ov{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;",
      "background:rgba(46,42,36,.55);backdrop-filter:blur(3px);opacity:0;transition:opacity .35s ease;padding:1.2rem}",
      ".ruts-pop__ov.is-on{opacity:1}",
      ".ruts-pop{position:relative;width:min(94vw,1000px);max-height:90vh;display:flex;background:" + (C.panel || "#F4EEE2") + ";color:" + (C.text || "#2E2A24") + ";border-radius:6px;",
      "overflow:hidden;box-shadow:0 24px 70px rgba(46,42,36,.35);transform:translateY(14px);",
      "transition:transform .4s cubic-bezier(.2,.7,.2,1);font-family:var(--font-body--family,inherit)}",
      ".ruts-pop__ov.is-on .ruts-pop{transform:translateY(0)}",
      ".ruts-pop__img{flex:0 0 40%;min-height:420px;position:relative;" + imgD_css + "}",
      ".ruts-pop__img::after{content:attr(data-eyebrow);position:absolute;left:0;right:0;bottom:1.2rem;text-align:center;",
      "color:rgba(244,238,226,.85);letter-spacing:.34em;font-size:.62rem}",
      ".ruts-pop__panel{flex:1 1 60%;padding:2.8rem 2.4rem;text-align:center;display:flex;flex-direction:column;justify-content:center;overflow-y:auto}",
      ".ruts-pop__x{position:absolute;top:.6rem;right:.85rem;z-index:2;background:rgba(244,238,226,.55);border:0;",
      "width:1.9rem;height:1.9rem;border-radius:50%;font-size:1.35rem;line-height:1;color:#2E2A24;cursor:pointer}",
      ".ruts-pop__x:hover{background:#F4EEE2}",
      ".ruts-pop__mark{color:" + (C.accent || "#A85A3C") + ";letter-spacing:.35em;font-size:.78rem;margin-bottom:.5rem}",
      ".ruts-pop h3{font-family:var(--font-heading--family,Georgia,serif);font-weight:500;font-size:2rem;line-height:1.12;margin:.1rem 0 .5rem}",
      ".ruts-pop p{font-size:.92rem;line-height:1.5;color:#5c5446;margin:0 auto 1.1rem;max-width:32ch}",
      ".ruts-pop form{display:flex;flex-direction:column;gap:.6rem}",
      ".ruts-pop input[type=email]{width:100%;padding:.85rem 1rem;border:1px solid " + border + ";border-radius:4px;",
      "background:#fff;font-size:.95rem;color:#2E2A24;text-align:center}",
      ".ruts-pop input[type=email]:focus{outline:none;border-color:" + (C.accent || "#A85A3C") + "}",
      ".ruts-pop button.ruts-pop__cta{width:100%;padding:.9rem 1rem;border:0;border-radius:4px;background:" + (C.btn_bg || "#2E2A24") + ";color:" + (C.btn_text || "#F4EEE2") + ";",
      "font-size:.8rem;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;transition:background .2s}",
      ".ruts-pop button.ruts-pop__cta:hover{background:" + (C.accent || "#A85A3C") + "}",
      ".ruts-pop__fine{font-size:.72rem;color:#9a8f7d;margin:.7rem 0 0}",
      ".ruts-pop__err{font-size:.78rem;color:" + (C.accent || "#A85A3C") + ";margin:.6rem 0 0}",
      ".ruts-pop__code{display:inline-block;margin:.4rem 0 .2rem;padding:.6rem 1.1rem;border:1px dashed " + (C.code || "#A85A3C") + ";border-radius:4px;",
      "font-size:1.15rem;letter-spacing:.18em;font-weight:600;color:" + (C.code || "#A85A3C") + ";background:#fff;cursor:pointer}",
      ".ruts-pop__no{display:block;margin-top:.9rem;background:none;border:0;color:#9a8f7d;font-size:.74rem;cursor:pointer;text-decoration:underline}",
      ".ruts-pop__no:hover{color:" + (C.accent || "#A85A3C") + "}",
      "@media (max-width:600px){",
      ".ruts-pop__ov{padding:.8rem}",
      ".ruts-pop{flex-direction:column;max-width:94vw;width:94vw;max-height:90vh;overflow-y:auto;scale:.7;transform-origin:center}",
      ".ruts-pop__img{flex:none;width:100%;min-height:0;height:" + hM + "px;" + imgM_css + "}",
      ".ruts-pop__img::after{bottom:.6rem}",
      ".ruts-pop__panel{flex:none;padding:1.5rem 1.25rem 1.6rem;overflow:visible}",
      ".ruts-pop h3{font-size:1.45rem}",
      ".ruts-pop p{font-size:.88rem;max-width:none}",
      "}"
    ].join("");
    document.head.appendChild(s);
  }

  function esc(str) { return (str || "").replace(/"/g, "&quot;"); }

  function build(state) {
    injectStyles();
    var ov = document.createElement("div");
    ov.className = "ruts-pop__ov";
    overlayEl = ov;
    ov.setAttribute("role", "dialog");
    ov.setAttribute("aria-modal", "true");
    ov.setAttribute("aria-label", CFG.title || "Descuento de bienvenida");

    var formHtml = CFG.show_form
      ? '<div data-ruts-form-slot></div>' +
        '<p class="ruts-pop__fine">' + (CFG.fine || "") + '</p>'
      : '<span class="ruts-pop__code" title="Copiar">' + (CFG.code || "") + '</span>' +
        '<form action="' + (CFG.shop_link || "/") + '" method="get"><button type="submit" class="ruts-pop__cta">' + (CFG.shop_text || "") + '</button></form>';

    ov.innerHTML =
      '<div class="ruts-pop">' +
        '<button class="ruts-pop__x" aria-label="Cerrar">&times;</button>' +
        '<div class="ruts-pop__img" aria-hidden="true" data-eyebrow="' + esc(CFG.eyebrow) + '"></div>' +
        '<div class="ruts-pop__panel">' +
          '<div class="ruts-pop__mark">' + (CFG.eyebrow || "") + '</div>' +
          '<div class="ruts-pop__body">' +
            '<h3>' + (CFG.title || "") + '</h3>' +
            (CFG.desc || "") +
            formHtml +
            '<button class="ruts-pop__no" type="button">' + (CFG.no || "No, gracias") + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov);

    requestAnimationFrame(function () { ov.classList.add("is-on"); });

    function close() { ov.style.pointerEvents = "none"; ov.classList.remove("is-on"); seen(); setTimeout(function () { ov.remove(); }, 360); }
    ov.querySelector(".ruts-pop__x").addEventListener("click", close);
    ov.querySelector(".ruts-pop__no").addEventListener("click", close);
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    document.addEventListener("keydown", function onEsc(e) {
      if (e.key === "Escape") { close(); document.removeEventListener("keydown", onEsc); }
    });

    function bindCopy(scope) {
      var codeEl = scope.querySelector(".ruts-pop__code");
      if (!codeEl) return;
      codeEl.addEventListener("click", function () {
        try { navigator.clipboard.writeText(CFG.code); codeEl.textContent = "¡Copiado!"; setTimeout(function () { codeEl.textContent = CFG.code; }, 1400); } catch (e) {}
      });
    }

    function success() {
      seen();
      var body = ov.querySelector(".ruts-pop__body");
      body.innerHTML =
        '<h3>' + (CFG.success_title || "¡Bienvenido!") + '</h3>' +
        '<p>' + (CFG.success_text || "Usa este código en el carrito:") + '</p>' +
        '<span class="ruts-pop__code" title="Copiar">' + (CFG.code || "") + '</span>' +
        '<p class="ruts-pop__fine">Toca el código para copiarlo.</p>' +
        '<form action="' + (CFG.shop_link || "/collections/novedades") + '" method="get"><button type="submit" class="ruts-pop__cta">' + (CFG.shop_text || "Empezar a comprar") + '</button></form>';
      bindCopy(body);
    }

    if (state === "success") { success(); return; }

    if (!CFG.show_form) { bindCopy(ov); return; }

    // Reubica el formulario NATIVO de Shopify ({% form 'customer' %}) dentro del popup,
    // conservando el reCAPTCHA que Shopify ya enlazó a ese formulario.
    var slot = ov.querySelector("[data-ruts-form-slot]");
    var nativeForm = document.querySelector("[data-ruts-popup-form] form");
    if (nativeForm && slot) { slot.parentNode.replaceChild(nativeForm, slot); }

    var form = ov.querySelector(".ruts-pop__body form");
    var input = form ? form.querySelector("input[type=email]") : null;
    if (input) setTimeout(function () { try { input.focus(); } catch (e) {} }, 420);

    function showError(msg) {
      if (!form) return;
      var err = form.parentNode.querySelector(".ruts-pop__err");
      if (!err) {
        err = document.createElement("p");
        err.className = "ruts-pop__err";
        form.parentNode.insertBefore(err, form.nextSibling);
      }
      err.textContent = msg;
    }

   if (form) {
  form.addEventListener("submit", function () {
    try {
      sessionStorage.setItem("ruts_popup_pending", "1");
    } catch (e) {}

    // No usar preventDefault:
    // Shopify debe poder completar reCAPTCHA y reenviar el formulario.
  }, true);
}
    if (state === "error") { showError("No se pudo completar la suscripción. Revisa el correo e inténtalo de nuevo."); }
  }

  function trigger() {
    if (CAME_FROM_POPUP && POSTED) { build("success"); return; }
    if (CAME_FROM_POPUP && !POSTED) { build("error"); return; }
    var fired = false;
    function go() { if (fired) return; fired = true; build(); }
    setTimeout(go, DELAY);
    if (CFG.exit_intent) {
      document.addEventListener("mouseout", function (e) {
        if (!fired && e.clientY <= 0 && (!e.relatedTarget)) go();
      });
    }
  }

  var normalArmed = false;

  function run(reason) {
    refreshConfig();
    if (!CFG || !CFG.enable) return;

    if (CFG.preview) {
      PREVIEW_ACTIVE = true;
      removeExisting();
      build();
      return;
    }

    PREVIEW_ACTIVE = false;
    if (window.Shopify && window.Shopify.designMode) { removeExisting(); }
    if (normalArmed) return;
    normalArmed = true;

    if (!CAME_FROM_POPUP && gated()) return;
    var path = location.pathname || "";
    if (!CAME_FROM_POPUP && /\/(checkout|account|challenge|password)/.test(path)) return;

    trigger();
  }
  window.__rutsPopupRun = run;

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (e) {
      var id = CFG && CFG.section_id;
      if (!id || (e.detail && e.detail.sectionId === id)) run("section:load");
    });
    document.addEventListener("shopify:section:select", function (e) {
      var id = CFG && CFG.section_id;
      if (!id || (e.detail && e.detail.sectionId === id)) run("section:select");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { run("init"); });
  } else { run("init"); }
})();
